import config from "../../src/common/default_config";

export default class options extends config {
  // default pdf rendering settings
  static subscriptionOptions = {
    authenticationProvider: "EMAIL_PASSWORD",
    subscriptionProvider: "TTG",
    subscriptionType: "subscription",
  };
  static socialSharingHash = "social";
  static allowNextgenPageSharing = true;
  static shareFromNextgen = true;
  static paywallRedirectionUrl = true;
  static paywallRedirectionNumber = 10000;
  static shareFromReader = true;
  static sharingOptions = {
    Facebook: true,
    GooglePlus: false,
    Twitter: true,
    Mail: true,
    WhatsApp: true,
    MailSubjectIntro: "",
  };
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;
  static homeRedirectionLink =
    "https://www.telegraph.co.uk/customer/subscribe/?icid=subs-offers_subsallaccess_house-apps_editionapp_inarticle";
  static enableTopNavDropdown = true;
}



// WEBPACK FOOTER //
// ./clients/tmg-ttg/config.js